import type { UsageRequestLogEntry } from '@nadoutong/contracts';
import type { SheetCell, SheetSpec } from './types.ts';
import { moneyYuan } from './money.ts';

/** Chinese headers for the request-log sheet — always zh, per #178. */
export const REQUEST_SHEET_HEADERS: readonly string[] = [
  '时间',
  '请求 ID',
  '密钥名称',
  '密钥 ID',
  '成员账号',
  '模型',
  '厂商',
  '协议',
  '状态码',
  '耗时(ms)',
  '首字节(ms)',
  '输入 Token',
  '输出 Token',
  '思考 Token',
  '图片输入 Token',
  '缓存读 Token',
  '缓存写 Token',
  '费用（元）',
  '计费状态',
];

export const REQUEST_SHEET_NAME = '请求日志';

export function assembleRequestSheet(
  rows: readonly UsageRequestLogEntry[],
  cnyPerUsd: number | null,
): SheetSpec {
  return {
    name: REQUEST_SHEET_NAME,
    rows: [REQUEST_SHEET_HEADERS, ...rows.map((row) => requestRow(row, cnyPerUsd))],
  };
}

function requestRow(row: UsageRequestLogEntry, cnyPerUsd: number | null): readonly SheetCell[] {
  const pending = (row.ratingStatus ?? 'rated') === 'pending';
  return [
    row.createdAt,
    row.requestId,
    row.apiKeyName ?? row.apiKeyPrefix ?? '',
    row.apiKeyId,
    row.memberAccountId ?? '',
    row.model,
    row.vendor,
    row.protocol,
    row.statusCode,
    row.latencyMs,
    row.clientResponseElapsedMs,
    row.inputTokens,
    row.outputTokens,
    row.reasoningTokens ?? null,
    row.imageInputTokens ?? null,
    row.cacheReadTokens,
    row.cacheWriteTokens,
    pending ? null : moneyYuan(row.costUsdMicros, row.costUsdCents, cnyPerUsd),
    pending ? '待计价' : billingStateLabel(row),
  ];
}

function billingStateLabel(row: UsageRequestLogEntry): string {
  if (row.unitBilling?.kind === 'not_charged') {
    return row.unitBilling.reason === 'pricing_review' ? '计价审核中' : '未计费';
  }
  const micros = row.costUsdMicros ?? row.costUsdCents * 10_000;
  return micros > 0 ? '已计费' : '未计费';
}
